const NO_PATH = '';
const SSTAR = '**';
const SLASH = '/';
const SVG = '.svg';
const PNG = '.png';
const PATH_USER = 'user';
const PATH_SIGNIN = 'signin';
const PATH_ASSETS = 'assets';
const PATH_ICONS = 'icons';

const ROUTE_USER_LOGIN = `${SLASH}${PATH_USER}${SLASH}${PATH_SIGNIN}`;

// routes goes from here
const ROUTE_ASSETS_ICON = `${PATH_ASSETS}${SLASH}${PATH_ICONS}${SLASH}`;

export {
    NO_PATH,
    SSTAR,
    ROUTE_ASSETS_ICON,
    ROUTE_USER_LOGIN,
    SVG,
    PNG
};
